import { api } from "@services/api";
import {
  type CompleteShippingAgencyTransferPayload,
  type PreviousShippingAgencyTransfersResponse,
  type ShippingAgencyTransfer,
  type ShippingAgencyTransferPayload,
} from "@services/shipping-agency-transfer/types";

export const getShippingAgencyTransfers = async (
  service: string,
  payload: {
    pageSize?: number;
    pageNumber?: number;
    vesselCallId: string;
    statuses?: readonly string[];
  },
) => {
  return api.get<PreviousShippingAgencyTransfersResponse>(service, `shipping-agency-transfers`, {
    params: payload,
  });
};

export const getLatestShippingAgencyTransfer = async (
  service: string,
  payload: { vesselCallId: string },
): Promise<ShippingAgencyTransfer | null> => {
  return api.get<ShippingAgencyTransfer | null>(
    service,
    `vessel-calls/${payload.vesselCallId}/shipping-agency-transfers/latest`,
  );
};

export const getShippingAgencyTransferById = async (service: string, id: string) => {
  return api.get<ShippingAgencyTransfer>(service, `shipping-agency-transfers/${id}`);
};

export const postShippingAgencyTransfer = async ({
  service,
  shippingAgencyTransferPayload,
  transactionId,
}: {
  service: string;
  shippingAgencyTransferPayload: ShippingAgencyTransferPayload;
  transactionId?: string;
}) => {
  return api.post<ShippingAgencyTransfer>(
    service,
    "shipping-agency-transfers",
    shippingAgencyTransferPayload,
    ...(transactionId ? [{ transactionId }] : []),
  );
};

export const cancelShippingAgencyTransfer = async (
  service: string,
  id: string,
  transactionId?: string,
) => {
  return api.put<void>(
    service,
    `shipping-agency-transfers/${id}:cancel`,
    ...(transactionId ? [undefined, { transactionId }] : []),
  );
};

export const claimShippingAgencyTransferById = async ({
  service,
  id,
  transactionId,
}: {
  service: string;
  id: string;
  transactionId?: string;
}) => {
  return api.put(
    service,
    `shipping-agency-transfers/${id}:claim`,
    ...(transactionId ? [undefined, { transactionId }] : []),
  );
};

export const unclaimShippingAgencyTransferById = async ({
  service,
  id,
  transactionId,
}: {
  service: string;
  id: string;
  transactionId?: string;
}) => {
  return api.put(
    service,
    `shipping-agency-transfers/${id}:unclaim`,
    ...(transactionId ? [undefined, { transactionId }] : []),
  );
};

export const completeShippingAgencyTransferById = async ({
  service,
  id,
  payload,
  transactionId,
}: {
  service: string;
  id: string;
  payload: CompleteShippingAgencyTransferPayload;
  transactionId?: string;
}) => {
  return api.put(
    service,
    `shipping-agency-transfers/${id}:complete`,
    payload,
    ...(transactionId ? [{ transactionId }] : []),
  );
};

export const getTransfersForVessel = async (
  service: string,
  vesselId: string,
  payload: {
    pageNumber?: number;
    pageSize?: number;
    statuses?: readonly string[];
  },
) => {
  return api.get<PreviousShippingAgencyTransfersResponse>(
    service,
    `shipping-agency-transfers/vessel/${vesselId}`,
    {
      params: payload,
    },
  );
};
